'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Rules.WhatIf'];
module.exports = angular.module('AVRO.Rules.WhatIfPopOver', dependencies).controller('WhatIfPopoverController', require('./controllers/WhatIfPopoverController')).directive('rmWhatIfPopover', require('./directives/WhatIfPopoverDirective'));